export const SYMBOLS = {
  emptyText: '-',
  phone: {
    prefix: '+',
    thousandSeparator: '',
  },
};
